import { format } from 'date-fns';
import { formatInTimeZone } from 'date-fns-tz';
import { isEmpty, upperFirst } from 'lodash';
import Cookies from 'universal-cookie';

const getHostScheduleDetailResponse = (response) => {
  const cookies = new Cookies();
  const timezone = cookies.get('organization').timezone;
  const startDate = new Date(response.startedAt);
  const endDate = new Date(response.endedAt);

  const achievements = response.accountAchievement?.map((account) => {
    let state = '';

    if (!isEmpty(account?.achievement)) state = 'achievement-available';
    else if (response?.isPastTwentyFourHours && isEmpty(account?.achievement)) state = 'achievement-error';
    else if (!response?.isPastTwentyFourHours) state = 'achievement-unavailable';

    return {
      name: account?.name ? upperFirst(account?.name) : '-',
      platform: account?.ecommerce?.name ?? '-',
      totalDuration: account?.achievement?.hours ?? 0,
      totalBuyer: account?.achievement?.buyer ?? 0,
      totalViewer: account?.achievement?.viewer ?? 0,
      totalRevenue: account?.achievement?.revenue ?? 0,
      convertionRate: account?.achievement?.conversationRate ?? 0,
      state,
    };
  });

  const schedule = {
    id: response.id,
    title: response.title,
    hasAchievement: response?.achievementStatus !== 'Hide Achievement',
    achievementStatus: response?.achievementStatus && response?.achievementStatus !== 'Hide Achievement' ? response?.achievementStatus : '',
    datetime: `${format(startDate, 'dd MMM yyyy')} | ${formatInTimeZone(startDate, timezone, 'HH:mm')}-${formatInTimeZone(endDate, timezone, 'HH:mm')}`,
    account: response.accountAchievement?.map((account) => `${account?.name} (${account?.ecommerce?.name})`).join(' | '),
    platform: response.accountAchievement?.map((account) => account?.ecommerce?.name).join(' | '),
    room: `${response?.studio?.room} - ${response?.studio?.name}`,
    host: response.hosts.map((host) => host?.name).join(' | '),
    operator: response.operators.map((operator) => operator?.name).join(' | '),
    rawData: response,
    reschedule: response?.reschedule,
    isHasRescheduled: response?.isHasRescheduled,
    isCanRequestReschedule: response?.isCanRequestReschedule,
    hasReschedule: response?.reschedule !== null,
    achievements,
  };

  return schedule;
};

export default getHostScheduleDetailResponse;
